<app-default-layout [title]="'Konto entsperren'">
  <div class="row" style="text-align: center">
    @if (httpFinished) {
      <h4 class="col-md-12">
        {{text}}
      </h4>
    }
  </div>
</app-default-layout>
